import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageHeaderContainer = styled('div')(({theme}) => ({
  marginBottom: theme.spacing(3),
}));

export const PageTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '1.5rem',
  color: 'var(--primary-main)',
}));

export const PageDescription = styled(Typography)(() => ({
  fontSize: '1rem',
  color: 'rgba(0, 0, 0, 0.6)',
  marginTop: '4px',
}));